import type {CSSProperties, ReactElement, ReactNode} from "react";
import {subThemes} from "../css/themes/themes.css";
import cx from "../utils/cx";
import {Col, css, Row, Text} from "./Box/Box";
import type {DSIconProps} from "./DSIcon/DSIcon";
import {DSIcon} from "./DSIcon/DSIcon";

const typeToColor: Record<NonNullable<Props["type"]>, keyof typeof subThemes> = {
  info: "brand",
  warn: "warn",
  success: "active",
  alert: "alert",
};

const typeToIconName: Record<NonNullable<Props["type"]>, DSIconProps["name"]> = {
  info: "Info",
  warn: "Warning",
  success: "Check",
  alert: "Close",
};

type Props = {
  children: ReactNode;
  title?: string | ReactElement;
  type?: "info" | "warn" | "success" | "alert";
  subTheme?: keyof typeof subThemes;
  iconName?: DSIconProps["name"] | null;
  action?: ReactNode;
  actionsBelow?: boolean;
  className?: string;
  style?: CSSProperties;
};
export const DSCallout = ({
  children,
  title,
  type = "info",
  subTheme = typeToColor[type],
  action,
  iconName = typeToIconName[type],
  actionsBelow,
  className,
  style,
}: Props) => (
  <Row
    as="aside"
    {...(action && actionsBelow ? {px: "16px", pt: "16px", pb: "8px"} : {pa: "16px"})}
    className={cx(subThemes[subTheme], className)}
    bg
    border="1px"
    rounded={4}
    sp={title ? "12px" : "8px"}
    relative
    style={style}
  >
    {iconName && (
      <DSIcon name={iconName} label={null} size={20} className={css({color: "secondary"})} />
    )}
    <Col sp="4px" pt="1px" flex="auto" minWidth="0">
      {title && (
        <Text type="label16" as="h3" color="primary">
          {title}
        </Text>
      )}
      <Text type="prose14" color="secondary">
        {children}
      </Text>
      {action && actionsBelow && (
        <Row flex="none" sp="8px" ml="auto" pt="8px" align="center" maxWidth="100%">
          {action}
        </Row>
      )}
    </Col>
    {action && !actionsBelow && (
      <Row
        flex="none"
        sp="8px"
        ml="auto"
        style={{marginTop: -4, marginBottom: -4}}
        align="center"
        maxWidth="100%"
      >
        {action}
      </Row>
    )}
  </Row>
);
